import { createFileRoute } from '@tanstack/react-router';

import { automaticSplitListScreen, automaticSplitListSearch, loadAutomaticSplitMessages, loadAutomaticSplitScreens } from '@/modules/automatic-split/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Split automático no caminho do legado (`router.tsx:645-669`): o menu passa a apontar para cá quando o
// manifesto entra em `src/app/screens.ts`. Arquivo leve (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/contas-digitais/split-automatico/')({
  validateSearch: automaticSplitListSearch,
  staticData: { screen: automaticSplitListScreen },
  loader: () => loadAutomaticSplitMessages(),
  component: lazyScreen(loadAutomaticSplitScreens, 'AutomaticSplitListRouteScreen'),
});
